/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-15 17:18:35
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import { modalFactory } from 'src/util/vueExtend';
import CompleteLog from './completeLog';

export namespace CompleteLogVOI {
    export interface PropsI {
        mn?: number;
        name?: string;
    }
}

@Component
class CompleteLogModal extends Vue.Component<CompleteLogVOI.PropsI> {
    @Prop({
        type: String,
    })
    mn!: string;

    @Prop({
        type: String,
    })
    name!: string;

    visible: boolean = false;

    close() {
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    render(h) {
        return (
            <Modal
                title={'补遗日志'}
                width="800"
                footer-hide
                class-name="wqms-data-complete-modal"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
            >
                <CompleteLog mn={this.mn} name={this.name}/>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertCompleteLogModal(mn: string, name: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<CompleteLogVOI.PropsI>(CompleteLogModal)({
            mn,
            name,
        });
        resolve();
    });
}
